<template>
  <!-- Begin Page Content -->
  <div class="container">
    <div class="card mb-4"  v-if="customerData && customerData.role=='student'">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h3 class="m-0 font-weight-bold text-primary">Сайн байна уу {{customerData.name}}  / {{customerData.code}} / оюутан</h3>
          </div>
  
        </div>
      </div>
      <div class="card-body bg-white">
        <p><span class="font-weight-bold">Нэр:</span> {{customerData.name}}</p>
        <p><span class="font-weight-bold">Овог:</span>  {{customerData.lastname}}</p>
        <p ><span class="font-weight-bold">Оюутны код:</span>  {{customerData.code}}</p>
        <p ><span class="font-weight-bold">Регистрийн дугаар:</span>  {{customerData.register}}</p>
        <p ><span class="font-weight-bold">Имэйл:</span>  {{customerData.email}}</p>
        <p ><span class="font-weight-bold">Утасны дугаар:</span>  {{customerData.phone}}</p>
        <p v-if="customerData.school"><span class="font-weight-bold">Сургууль:</span>  {{customerData.school.id}}</p>
        <p v-if="customerData.departmentData"><span class="font-weight-bold">Xөтөлбөрийн баг:</span>  {{customerData.departmentData.name}}</p>
        <p v-if="customerData.programData"><span class="font-weight-bold">Хөтөлбөр: </span> {{customerData.programData.name}}</p>
        <p v-if="customerData.programplanData" style="cursor:pointer;" @click="$router.push({name:'StudentProgramPlan', params:{ schoolId: customerData.school.id, departmentId: customerData.department.id, programId: customerData.program.id, programYearId: customerData.programYear.id}})">
          <span class="font-weight-bold">Мэргэжлийн төлөвлөгөө: </span> 
          <span class="text-primary"> {{customerData.programplanData.name}} / {{customerData.programplanData.degreeName}} </span>
          <span v-if="customerData.programplanData.duration">/ {{customerData.programplanData.duration}} жил</span>
        </p>
   
      </div>
    </div>
    <div class="card mb-4"  v-if="customerData && customerData.role=='teacher'">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h3 class="m-0 font-weight-bold text-primary">Сайн байна уу {{customerData.name}}  / {{customerData.code}} / багш</h3>
          </div>
  
        </div>
      </div>
      <div class="card-body bg-white">
        <p><span class="font-weight-bold">Нэр:</span>  {{customerData.name}}</p>
        <p><span class="font-weight-bold">Овог:</span>  {{customerData.lastname}}</p>
        <p ><span class="font-weight-bold">Багшийн код:</span>  {{customerData.code}}</p>
        <p ><span class="font-weight-bold">Имэйл:</span>  {{customerData.email}}</p>
        <p ><span class="font-weight-bold">Утасны дугаар: </span> {{customerData.phone}}</p>
        <p v-if="customerData.school"><span class="font-weight-bold">Сургууль:</span>  {{customerData.school.id}}</p>
        <p v-if="customerData.departmentData"><span class="font-weight-bold">Xөтөлбөрийн баг:</span>  {{customerData.departmentData.name}}</p>

          
      </div>
    </div>

    <div class="card mb-4 bg-white"  v-if="customerData && customerData.role=='admin'">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h3 class="m-0 font-weight-bold text-primary">Сайн байна уу {{customerData.name}}  /  Захирал ADMIN</h3>
          </div>
  
        </div>
      </div>
      <div class="card-body bg-white">
        <p><span class="font-weight-bold">Нэр:</span>  {{customerData.name}}</p>
        <p><span class="font-weight-bold">Овог:</span>  {{customerData.lastname}}</p>
        <p ><span class="font-weight-bold">Имэйл:</span>  {{customerData.email}}</p>
        <p ><span class="font-weight-bold">Утасны дугаар: </span> {{customerData.phone}}</p>
          
      </div>
    </div>

    <div class="card mb-4 bg-white"  v-if="customerData && customerData.role=='sts'">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h3 class="m-0 font-weight-bold text-primary">Сайн байна уу {{customerData.name}}  /  Захирал багш</h3>
          </div>
  
        </div>
      </div>
      <div class="card-body bg-white">
        <p><span class="font-weight-bold">Нэр:</span>  {{customerData.name}}</p>
        <p><span class="font-weight-bold">Овог:</span>  {{customerData.lastname}}</p>
        <p ><span class="font-weight-bold">Имэйл:</span>  {{customerData.email}}</p>
        <p ><span class="font-weight-bold">Утасны дугаар: </span> {{customerData.phone}}</p>
        <p v-if='customerData.schools && customerData.schools.length>0'>
          <span class="font-weight-bold">Сургууль: </span>
          <ul>
            <li v-for="school in customerData.schools">{{school.id}}</li>
          </ul>
        </p>
      </div>
    </div>

    <div class="card mb-4 bg-white"  v-if="customerData && customerData.role=='manager'">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h3 class="m-0 font-weight-bold text-primary">Сайн байна уу {{customerData.name}}  /  Менежер</h3>
          </div>
  
        </div>
      </div>
      <div class="card-body bg-white">
        <p><span class="font-weight-bold">Нэр:</span>  {{customerData.name}}</p>
        <p><span class="font-weight-bold">Овог:</span>  {{customerData.lastname}}</p>
        <p ><span class="font-weight-bold">Имэйл:</span>  {{customerData.email}}</p>
        <p ><span class="font-weight-bold">Утасны дугаар: </span> {{customerData.phone}}</p>
        <p v-if='customerData.schools && customerData.schools.length>0'>
          <span class="font-weight-bold">Сургууль: </span>
          <ul>
            <li v-for="school in customerData.schools">{{school.id}}</li>
          </ul>
        </p>
      </div>
    </div>

        
        </div>
        <!-- /.container-fluid -->
</template>

<script>
import { mapState } from 'vuex';
const fb = require("../firebaseConfig.js");
export default {
  name: "Dashboard",
  data() {
    return {
      customerData:null
    };
  },
  computed: {
    ...mapState(['currentUser', 'userProfile'])
  },
  methods: {
    _getData(){
      
      if(this.userProfile && this.userProfile.customer){
        this.userProfile.customer.get().then(doc=>{
          let data=doc.data();
          data.id=doc.id;
          if(this.userProfile.role=="student"){
            data.departmentData=null;
            data.programData=null;
            data.programplanData=null;
            
            if(data.department){
              data.department.get().then(ddoc=>{
                if(ddoc.exists){
                  data.departmentData=ddoc.data();
                }
              })
            }

            if(data.program){
              data.program.get().then(ddoc=>{
                if(ddoc.exists){
                  data.programData=ddoc.data();
                }
              })
            }

            if(data.programYear){
              data.programYear.get().then(ddoc=>{
                if(ddoc.exists){
                  data.programplanData=ddoc.data();
                }
              })
            }

    
          }
          if(this.userProfile.role=="teacher"){
            data.departmentData=null;
            
            if(data.department){
              data.department.get().then(ddoc=>{
                if(ddoc.exists){
                  data.departmentData=ddoc.data();
                }
              })
            }

          }
          data.role=this.userProfile.role;
          this.customerData=data;
        });
      }
    }
  },
  created(){
    this._getData();
  }
  
};
</script>

<style scoped>
p {
    margin-top: 0;
    margin-bottom: 0.5rem;
}
</style>